import React, { useEffect, useState } from "react";
import Header from "../Header";
import Footer from "../Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { getAuthToken } from "../../utils/auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchSinglePost } from "../../utils/PostComponents";
import DataTable from "react-data-table-component";
import { fetchLoginUser } from "../../utils/UserComponents";

const Base_Url = process.env.REACT_APP_BASE_URL;

const ViewSinglePost = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [postData, setPostData] = useState();
  const [userData, setUserData] = useState();
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [loading, setLoading] = useState(true);
  const [shouldTruncate, setShouldTruncate] = useState(false);

  useEffect(() => {
    const id = location.pathname.split("/").pop();
    let truncated = true;
    fetchSinglePost(id, setPostData, setShouldTruncate, truncated);
    fetchLoginUser(setUserData);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [location.pathname]);

  const handleDonateForm = async () => {
    try {
      const token = getAuthToken();
      if (token) {
        if (userData.role === "admin") {
          navigate("/payment", {
            state: { postData: postData, userData: userData._id },
          });
        } else {
          if (
            userData &&
            Object.values(userData).every(
              (field) => field !== "" && field !== null && field !== undefined
            )
          ) {
            navigate("/payment", {
              state: { postData: postData, userData: userData._id },
            });
          } else {
            toast.error("Please complete your profile");
          }
        }
      } else {
        toast.error("Please login");
      }
    } catch (e) {
      toast.error("Server Error");
    }
  };

  const getTruncatedDescription = (description) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(description, "text/html");
    const textContent = doc.body.textContent || "";
    const truncatedText =
      textContent.split(/\s+/).slice(0, 50).join(" ") + "...";
    const newDoc = document.implementation.createHTMLDocument();
    newDoc.body.textContent = truncatedText;

    return newDoc.body.innerHTML;
  };

  const handleView = (user) => {
    navigate(`/view/user/profile/${user.user_id}`);
  };

  const columns = [
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Email", selector: (row) => row.email, sortable: true },
    { name: "Paid Amount", selector: (row) => row.amount, sortable: true },
    {
      name: "",
      cell: (row) => (
        <div className="donates-btns-users">
          <button className="donate-btn" onClick={() => handleView(row)}>
            View
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.user_id === userData?._id,
      style: {
        backgroundColor: "#ffefd4",
      },
    },
  ];

  return (
    <>
      <Header />
      <ToastContainer />
      {loading ? (
        <div className="container loading-dots">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </div>
      ) : (
        <>
          <div className="single-post-container">
            <div className="single-post-image">
              <img
                src={`${Base_Url}/assets/postThumbnails/${postData.attachment}`}
                alt={postData.title}
              />
            </div>
            <div className="single-post-details">
              <div className="single-post-details-top">
                <h1>{postData.title}</h1>
                <h6>$ {postData.amount}</h6>
                <h3>
                  {" "}
                  Amount already paid : ${" "}
                  {postData.paidAmount ? postData.paidAmount : "0"}
                </h3>
                <p className="description">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: shouldTruncate
                        ? getTruncatedDescription(postData.description)
                        : postData.description,
                    }}
                  />
                  {shouldTruncate && (
                    <button
                      onClick={() =>
                        setShowFullDescription(!showFullDescription)
                      }
                    >
                      {showFullDescription ? "Read Less" : "Read More"}
                    </button>
                  )}
                </p>
              </div>
              <div className="donate-button-div">
                <button
                  className="donate-button"
                  onClick={() => {
                    if (
                      postData?.paidAmount !== undefined &&
                      Number(postData.paidAmount) === Number(postData.amount)
                    ) {
                      toast.info(
                        "The full donation amount has already been paid."
                      );
                    } else {
                      handleDonateForm();
                    }
                  }}
                >
                  Donate Now
                </button>
              </div>
            </div>
          </div>

          {showFullDescription && (
            <div className="content-details-decsrption">
              <div className="custom_container">
                <h2>Description</h2>
                <p
                  dangerouslySetInnerHTML={{ __html: postData.description }}
                ></p>
              </div>
            </div>
          )}

          {postData.paidBy.length > 0 && (
            <div className="custom_table">
              <div className="custom_container">
                <DataTable
                  className="custom_table_inner"
                  columns={columns}
                  data={postData?.paidBy}
                  pagination
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[10, 20]}
                  conditionalRowStyles={conditionalRowStyles}
                />
              </div>
            </div>
          )}
        </>
      )}
      <Footer />
    </>
  );
};

export default ViewSinglePost;
